import { MailParams } from '@dadohr/shared/domainTypes/mail';
import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../firebaseFunctions';

export const sendPreviewTeamsMessage = (
  params: MailParams,
  recipientEmail: string,
  orgId: string
) => {
  console.log('sendPreviewTeamsMessage');
  console.log('params', params);
  return callFirebaseFunction(CF.microsoft.teams.sendPreviewTeamsMessage, {
    params,
    recipientEmail,
    orgId
  });
};
